import { FC, SVGProps } from 'react';

export const TimerIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M3.03123 9.33552C3.39853 5.48702 6.81612 2.66494 10.6646 3.03224C14.5131 3.39954 17.3352 6.81713 16.9679 10.6656C16.6006 14.5141 13.183 17.3362 9.33452 16.9689"
      stroke="#BCB9B3"
      strokeWidth="1.85"
      strokeLinecap="round"
    />
    <path d="M5.00006 9.49999L3.00002 11.5L1 9.50001" stroke="#BCB9B3" strokeWidth="1.85" strokeLinecap="round" />
    <path d="M9 11V6H11V11H9Z" fill="#BCB9B3" />
    <path d="M9 11V9H13V11H9Z" fill="#BCB9B3" />
  </svg>
);
